import Swiper from 'swiper';
const random = require("random-js")();

import './index.scss';

const SOUND_NAME_INDEX_START = 1;
const SOUND_NAME_INDEX_END   = 69;

const SIZE_MOBILE = 991;

class App {
  constructor({
    rootEl,
    videoWidth,
    videoHeight,
    imgWidth,
    imgHeight,
  }) {
    this.videoWidth = videoWidth;
    this.videoHeight = videoHeight;
    this.imgWidth = imgWidth;
    this.imgHeight = imgHeight;
    this.sounds = [];
    this.currSoundIndex = 0;
    this.soundIsLoading = false;

    this.cacheDomEls(rootEl);
    this.initGallery();
    this.initSounds();
    this.bindEvents();
    this.resizeAll();
  }

  cacheDomEls(rootEl) {
    this.dom = {
      rootEl: rootEl,
      processVideoEl: rootEl.querySelector('.PechkaHowItWasSection iframe'),
      backstageVideoEl: rootEl.querySelector('.PechkaAuthorsSection iframe'),
      galleryEl: rootEl.querySelector('.PechkaHowItWasSection-gallery .swiper-container'),
      playSoundButtonEl: rootEl.querySelector('.Pechka-playSoundButton'),
      soundsSpawnAreaEl: rootEl.querySelector('.Pechka-soundsSpawnArea'),
    };
  }

  initGallery() {
    new Swiper('.swiper-container', {
      loop: true,
      pagination: '.swiper-pagination',
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev',
      paginationClickable: true,
      preloadImages: false,
      lazyLoading: true,
      lazyLoadingInPrevNext: true,
    });
  }

  initSounds() {
    const {sounds} = this;

    for (let i = SOUND_NAME_INDEX_START; i <= SOUND_NAME_INDEX_END; i++) {
      let path = i;
      if (i < 10) {
        name = `00${i}`;
      } else if (i < 100) {
        name = `0${i}`;
      }
      path = `assets/sounds/${name}.mp3`;
      sounds.push({
        path,
        audio: null,
      });
    }

    this.sounds = random.shuffle(sounds);
  }

  bindEvents() {
    window.addEventListener('resize', this.onResize, false);
    this.dom.playSoundButtonEl.addEventListener('click', this.onPlaySoundButtonClick, false);
    this.dom.playSoundButtonEl.addEventListener('touchstart', this.onPlaySoundButtonClick, false);
  }

  onResize = () => {
    this.resizeAll();
  };

  onPlaySoundButtonClick = (event) => {
    event.preventDefault();

    this.playSound();
  };

  playSound() {
    const {
      soundIsLoading,
      sounds,
      currSoundIndex,
    } = this;

    if (soundIsLoading) {
      return;
    }
    const currSound = sounds[currSoundIndex];
    const {
      path,
      audio,
    } = currSound;

    if (!audio) {
      this.soundIsLoading = true;
      const newAudio = new Audio(path);
      if (newAudio.volume > 0.5) {
        newAudio.volume = 0.5;
      }
      this.soundIsLoading = false;
      sounds[currSoundIndex].audio = newAudio;
      this.playSound();
      newAudio.addEventListener('canplaythrough', () => {

      }, false);

      return;
    }

    audio.play();
    let newSoundIndex = this.currSoundIndex + 1;
    if (newSoundIndex >= sounds.length) {
      newSoundIndex = 0;
    }
    this.createAndAnimatesNotes();
    this.currSoundIndex = newSoundIndex;
  }

  createAndAnimatesNotes() {
    const {soundsSpawnAreaEl} = this.dom;
    const noteCount = 2 + random.integer(5,8);
    const notes = [];
    for (let i = 0; i < noteCount; i++) {
      const el = document.createElement('div');
      el.className = 'Pechka-soundNote';
      const size = 30 + random.integer(-4, 4) * 5;
      const deltaX = random.integer(-10, 7) * 10;
      el.style.width = `${size}px`;
      el.style.height = `${size}px`;
      el.style.left = `${deltaX}px`;
      el.style.opacity = 1;
      notes.push(el);
    }
    for (let i = 0; i < noteCount; i++) {
      const el = notes[i];
      soundsSpawnAreaEl.appendChild(el);
    }

    setTimeout(() => {
      for (let i = 0; i < noteCount; i++) {
        const el = notes[i];
        const deltaX = 50 + random.integer(-10, 10) * 10;
        const deltaY = -140 + random.integer(-1, 6) * 2;
        el.style.transform = `translate(${deltaX}px,${deltaY}px)`;
        el.style.opacity = 0;
      }
    }, this.isMobileSize() ? 1200 : 500);

    setTimeout(() => {
      for (let i = 0; i < noteCount; i++) {
        const el = notes[i];
        soundsSpawnAreaEl.removeChild(el);
      }
    }, 10000);
  }

  resizeAll() {
    const {
      processVideoEl,
      backstageVideoEl,
      galleryEl
    } = this.dom;

    const {
      videoWidth,
      videoHeight,
      imgWidth,
      imgHeight,
    } = this;

    const processVideoWidth = processVideoEl.offsetWidth;
    const newProcessVideoHeight = Math.round(processVideoWidth * videoHeight / videoWidth);
    processVideoEl.setAttribute('height', newProcessVideoHeight);

    const backstageVideoWidth = processVideoEl.offsetWidth;
    const newBackstageVideoHeight = Math.round(backstageVideoWidth * videoHeight / videoWidth);
    backstageVideoEl.setAttribute('height', newBackstageVideoHeight);

    const galleryWidth = galleryEl.offsetWidth;
    const newGalleryHeight = Math.round(galleryWidth * imgHeight / imgWidth);
    galleryEl.style.height = `${newGalleryHeight}px`;
  }

  isMobileSize() {
    return window.innerWidth <= SIZE_MOBILE;
  }
}
window.App = App;



/** WEBPACK FOOTER **
 ** ./src/client/index.js
 **/